import { Component } from "components/common";

/**
 * Eine Klasse zur Erstellung von HTML `<a>` Elementen.
 *
 * @example
 * Das folgende Beispiel erstellt ein HTML `<a>` Element.
 *
 * Erstelle ein neues HTML `<a>` Element.
 *
 * ```typescript
 * import { Link } from "components/common/link";
 *
 * const link = new Link();
 * ```
 *
 * Konfiguriere das HTML `<a>` Element durch Method Chaining.
 *
 * ```typescript
 * link
 *     .withID("link")
 *     .withClass("link");
 * ```
 *
 * Rendere nun das HTML `<a>` Element in das DOM.
 *
 * ```typescript
 * document.getElementById("root")
 *     ?.replaceChildren(link.render());
 * ```
 *
 * @public
 */
class Link extends Component<HTMLAnchorElement> {
  /**
   * Erstellt ein neues HTML `<a>` Element.
   */
  constructor() {
    super(document.createElement("a"));
  }

  /**
   * Fügt eine URL hinzu.
   *
   * @param url - Eine URL.
   * @returns Das HTML `<a>` Element mit der URL.
   *
   * @public
   */
  public withURL(url: HTMLAnchorElement["href"]) {
    this.element.href = url;

    return this;
  }
}

export { Link };
